export enum ElementId {
  HeaderContainer = 'headerContainer',
  MenuContainer = 'menuContainer',
  AppsContainer = 'appsContainer',
}
